import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["fileInput", "form"];

  trigger(event) {
    event.preventDefault();
    this.fileInputTarget.click();
  }

  fileSelected() {
    if (this.fileInputTarget.files.length > 0) {
      this.formTarget.requestSubmit();
    }
  }
}
